import { render, staticRenderFns } from "./SiteNotAvailableTid2.vue?vue&type=template&id=73c8deb3&scoped=true"
import script from "./SiteNotAvailableTid2.vue?vue&type=script&lang=js"
export * from "./SiteNotAvailableTid2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73c8deb3",
  null
  
)

export default component.exports